// extracted by mini-css-extract-plugin
export var defaultWrapper = "_mk-3";
export var downloadButton = "_mk-4";
export var fileContainer = "_mk-9 _mk-7";
export var fileContainerBase = "_mk-7";
export var fileContainerFixedHeight = "_mk-8 _mk-7";
export var fileInfo = "_mk-5";
export var fileInfoWidthRestricted = "_mk-6";
export var fileType = "_mk-1";
export var fileTypeName = "_mk-2";
export var image = "_mk-0";
export var link = "_mk-b";
export var overflowEllipsis = "_mk-a";